import React from 'react';
import Typography from '@mui/material/Typography';

interface IRowProps {
  hit: any;
}

const EmbargoedData: React.FC<IRowProps> = ({ hit }) => {
  return (
    <>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['IP Address']}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source.Country}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['Country Code']}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['Embargo Status']}
        </Typography>
      </div>
    </>
  );
};

export default EmbargoedData;
